import { MemberProfileRoute } from '@ltvco/refresh-lib/fmt';
import { useParams } from 'react-router-dom';

export const MemberProfile = () => {
  const { member_id } = useParams();
  return <MemberProfileRoute member_id={member_id} />;
};
